import { sample, sampleSize } from 'lodash-es';

import { EnumType } from '@pflegia/types/common/types/enum.type';

export const randomEnumValue = <T extends EnumType>(enumType: T, exceptions: T[keyof T][] = []) =>
  sample(Object.values(enumType).filter(val => !exceptions.includes(val as T[keyof T]))) as T[keyof T];

export const randomEnumValues = <T extends EnumType>(enumType: T, count = 1, exceptions: T[keyof T][] = []) =>
  sampleSize(
    Object.values(enumType).filter(value => !exceptions.includes(value as T[keyof T])),
    count,
  ) as T[keyof T][];

export const getEnumValues = <T extends EnumType>(enumeration: T, exceptions?: T[keyof T][]): T[keyof T][] =>
  Object.values(enumeration).filter(value => !exceptions?.includes(value as T[keyof T])) as T[keyof T][];
